const getUrlImage = (url) => {
    return 'https://s3.ap-southeast-1.amazonaws.com/statics.serlita.com/' + url;
}

export default getUrlImage;